module.exports = __webpack_public_path__ + "static/img/zanwu.80ac901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zanwu.png
// module id = GWLQ
// module chunks = 1